export default __webpack_public_path__ + "static/media/arrow_right_white.d808feb2.svg";